import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TextBox } from 'devextreme-react/text-box'
import _ from "lodash"
import React, { FC, useCallback, useEffect, useState } from 'react'
import './search-box.scss'

type Props = {
    onSearch: (query: string) => void,
    searchQuery?: string,
    placeHolder: string,
    searchDelay?: number
}

export const SearchBox: FC<Props> = ({ placeHolder, searchQuery, onSearch, searchDelay = 750 }) => {

    const [searchValue, setSearchValue] = useState<string>(searchQuery ?? '')

    const searchAfterDelay = useCallback(_.debounce((query: string) => onSearch(query), searchDelay), []);

    const handleValueChanged = (e: any): void => {
        const newValue: string = e.value
        setSearchValue(newValue)
        searchAfterDelay(newValue)
    }

    useEffect(() => {
        setSearchValue(searchQuery ?? '')
    }, [searchQuery])

    return (
        <div className={'search-box-container'} >
            <FontAwesomeIcon color={'#FFA90A'} icon={faSearch as IconProp} size={'lg'} />
            <div className={'search-box-input'}>
                <TextBox
                    placeholder={placeHolder}
                    value={searchValue}
                    valueChangeEvent="keyup"
                    onValueChanged={handleValueChanged}
                />
            </div>
        </div>
    )
}